import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { ICompany } from './CompaniesManagementPage';
import { getCompanies as fetchCompanies } from './services';

// Define the context type
export interface CompaniesContextType {
  companies: ICompany[];
  loading: boolean;
  refreshCompanies: () => Promise<void>;
}

// Create context with default values
export const CompaniesContext = createContext<CompaniesContextType>({
  companies: [],
  loading: false,
  refreshCompanies: async () => {},
});

// Props for the provider component
interface CompaniesProviderProps {
  children: ReactNode;
}

// Create provider component
export const CompaniesProvider: React.FC<CompaniesProviderProps> = ({ children }) => {
  const [companies, setCompanies] = useState<ICompany[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // Function to fetch and refresh companies data
  const refreshCompanies = useCallback(async () => {
    setLoading(true);
    try {
      const fetchedCompanies = await fetchCompanies();
      setCompanies(fetchedCompanies);
    } catch (error) {
      console.error('Error fetching companies:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <CompaniesContext.Provider value={{ companies, loading, refreshCompanies }}>{children}</CompaniesContext.Provider>
  );
};
